// @ts-nocheck
import { Loader } from './assistUi/Loader';
import { Form } from './formUi/Form';
import { PrefBundlerBtn } from './formUi/PrefBundlerBtn';
import { PrefSlider } from './formUi/PrefSlider';
import { Select } from './formUi/Select';
import { SubmitBtn } from './formUi/SubmitBtn';
import { TasteBundlerBtn } from './formUi/TasteBundlerBtn';
import { TasteSlider } from './formUi/TasteSlider';
import { CourseCopyBtn } from './resultUi/CourseCopyBtn';
import { ReSearchBtn } from './resultUi/ReSearchBtn';
import { ResultMsg } from './resultUi/ResultMsg';
import { ResultNoItemMsg } from './resultUi/ResultNoItemMsg';
import { SpotItems } from './resultUi/SpotItems';
import translation from './translation';

export default class Aic {
  constructor({
    defaultLocale = 'ja',
    locale = 'ja' | 'en' | 'zh-hant' | 'th',
    aicAPIBaseURI,
    apiKey,
    place,
    wpAPIBaseURI,
    wpApiKey,
    activeTasteBundlerBtnId = 'pref-bundler-btn-1',
    activePrefBundlerBtnId = 'taste-bundler-btn-7',
    designActiveClassName = 'is-selected',
  }) {
    console.log('[Aic] locale:', locale);
    console.log('[Aic] constructor start');
    // Store
    //
    this.store = {
      config: {
        defaultLocale,
        locale,
        aicAPIBaseURI,
        apiKey,
        place,
        wpAPIBaseURI,
        wpApiKey,
        designActiveClassName,
        selector: {
          form: '[data-mp-role="aic-form"]',
          tasteBundlerBtn: '[data-mp-role="aic-taste-bundler-btn"]',
          prefBundlerBtn: '[data-mp-role="aic-pref-bundler-btn"]',
          prefSlider: '[data-mp-role="aic-pref-slider"]',
          tasteSlider: '[data-mp-role="aic-taste-slider"]',
          startSpotSelect: '[data-mp-role="aic-start-spot-selector"]',
          durationSelect: '[data-mp-role="aic-duration-selector"]',
          startTimeSelect: '[data-mp-role="aic-start-time-selector"]',
          daysSelect: '[data-mp-role="aic-days-selector"]',
          transportationSelect: '[data-mp-role="aic-transportation-selector"]',
          submitBtn: '[data-mp-role="aic-submit-btn"]',
          loader: '[data-mp-role="aic-loader"]',
          spotItems: '[data-mp-role="aic-spot-items"]',
          resultNoItemMsg: '[data-mp-role="aic-result-no-item-msg"]',
          resultMsg: '[data-mp-role="aic-result-msg"]',
          courseCopyBtn: '[data-mp-role="aic-course-copy-btn"]',
          reSearchBtn: '[data-mp-role="aic-re-search-btn"]',
        },
        selectTypes: [
          'startSpot',
          'duration',
          'startTime',
          'days',
          'transportation',
        ],
        wayTable: {
          1: {
            nameByAic: 'walk',
            nameByFa:
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="currentColor" class="icons w-full"><!--!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M320 144C350.9 144 376 118.9 376 88C376 57.1 350.9 32 320 32C289.1 32 264 57.1 264 88C264 118.9 289.1 144 320 144zM233.4 291.9L256 269.3L256 338.6C256 366.6 268.2 393.3 289.5 411.5L360.9 472.7C366.8 477.8 370.7 484.8 371.8 492.5L384.4 580.6C386.9 598.1 403.1 610.3 420.6 607.8C438.1 605.3 450.3 589.1 447.8 571.6L435.2 483.5C431.9 460.4 420.3 439.4 402.6 424.2L368.1 394.6L368.1 279.4L371.9 284.1C390.1 306.9 417.7 320.1 446.9 320.1L480.1 320.1C497.8 320.1 512.1 305.8 512.1 288.1C512.1 270.4 497.8 256.1 480.1 256.1L446.9 256.1C437.2 256.1 428 251.7 421.9 244.1L404 221.7C381 192.9 346.1 176.1 309.2 176.1C277 176.1 246.1 188.9 223.4 211.7L188.1 246.6C170.1 264.6 160 289 160 314.5L160 352C160 369.7 174.3 384 192 384C209.7 384 224 369.7 224 352L224 314.5C224 306 227.4 297.9 233.4 291.9zM245.8 471.3C244.3 476.5 241.5 481.3 237.7 485.1L169.4 553.4C156.9 565.9 156.9 586.2 169.4 598.7C181.9 611.2 202.2 611.2 214.7 598.7L283 530.4C294.5 518.9 302.9 504.6 307.4 488.9L309.6 481.3L263.6 441.9C261.1 439.7 258.6 437.5 256.2 435.1L245.8 471.3z"/></svg>',
            nameForGmap: 'walking',
          },
          2: {
            nameByAic: 'car',
            nameByFa:
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="currentColor" class="icons w-full"><!--!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M147 170.7L117.2 256L240.1 256L240.1 160L162.2 160C155.4 160 149.3 164.3 147.1 170.7zM48.6 257.9L86.5 149.6C97.8 117.5 128.1 96 162.1 96L360 96C385.2 96 408.9 107.9 424 128L520.2 256.3C587.1 260.5 640 316.1 640 384L640 400C640 435.3 611.3 464 576 464L559.6 464C555.6 508.9 517.9 544 472 544C426.1 544 388.4 508.9 384.4 464L239.7 464C235.7 508.9 198 544 152.1 544C106.2 544 68.5 508.9 64.5 464L64.1 464C28.8 464 .1 435.3 .1 400L.1 320C.1 289.9 20.8 264.7 48.7 257.9zM440 256L372.8 166.4C369.8 162.4 365 160 360 160L288 160L288 256L440 256zM152 496C174.1 496 192 478.1 192 456C192 433.9 174.1 416 152 416C129.9 416 112 433.9 112 456C112 478.1 129.9 496 152 496zM512 456C512 433.9 494.1 416 472 416C449.9 416 432 433.9 432 456C432 478.1 449.9 496 472 496C494.1 496 512 478.1 512 456z"/></svg>',
            nameForGmap: 'driving',
          },
          3: {
            nameByAic: 'train',
            nameByFa:
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="currentColor" class="icons w-full"><!--!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M480 64C568.4 64 640 135.6 640 224L640 448C640 483.3 611.3 512 576 512L570.4 512C557.2 549.3 521.8 576 480 576C438.2 576 402.7 549.3 389.6 512L250.5 512C237.3 549.3 201.8 576 160.1 576C118.4 576 82.9 549.3 69.7 512L64 512C28.7 512 0 483.3 0 448L0 160C0 107 43 64 96 64L480 64zM160 432C133.5 432 112 453.5 112 480C112 506.5 133.5 528 160 528C186.5 528 208 506.5 208 480C208 453.5 186.5 432 160 432zM480 432C453.5 432 432 453.5 432 480C432 506.5 453.5 528 480 528C506.5 528 528 506.5 528 480C528 453.5 506.5 432 480 432zM480 128C462.3 128 448 142.3 448 160L448 352C448 369.7 462.3 384 480 384L544 384C561.7 384 576 369.7 576 352L576 224C576 171 533 128 480 128zM248 288L352 288C369.7 288 384 273.7 384 256L384 160C384 142.3 369.7 128 352 128L248 128L248 288zM96 128C78.3 128 64 142.3 64 160L64 256C64 273.7 78.3 288 96 288L200 288L200 128L96 128z"/></svg>',
            nameForGmap: 'transit',
          },
        },
        translation,
      },
      state: {
        _activeTasteBundlerBtnId: undefined,
        _activePrefBundlerBtnId: undefined,
        _taste: {
          taste1: undefined,
          taste2: undefined,
          taste3: undefined,
          taste4: undefined,
        },
        _pref: {
          pref1: undefined,
          pref2: undefined,
          pref3: undefined,
          pref4: undefined,
          pref5: undefined,
          pref6: undefined,
          special: undefined,
        },
        _startSpot: undefined,
        _duration: undefined,
        _startTime: undefined,
        _days: undefined,
        _transportation: undefined,
        _aicAPIInfo: undefined,
        _wpAPIInfo: undefined,
        _mixInfo: undefined,
        _hasValidSpotData: undefined,
        _firstSubmit: false, // 一度でも検索を行ったかを取得可能
        _isFetching: undefined,
        _isShownForm: true,
      },
    };

    // Node of Form UI
    //

    this.form = new Form({
      app: this,
      node: document.querySelector(this.store.config.selector.form),
    });

    this.tasteBundlerBtns = [];
    document
      .querySelectorAll(this.store.config.selector.tasteBundlerBtn)
      .forEach((node) => {
        this.tasteBundlerBtns.push(new TasteBundlerBtn({ app: this, node }));
      });

    this.tasteSlider = new TasteSlider({
      app: this,
      node: document.querySelector(this.store.config.selector.tasteSlider),
    });

    this.prefBundlerBtns = [];
    document
      .querySelectorAll(this.store.config.selector.prefBundlerBtn)
      .forEach((node) => {
        this.prefBundlerBtns.push(new PrefBundlerBtn({ app: this, node }));
      });

    this.prefSliders = [];
    document
      .querySelectorAll(this.store.config.selector.prefSlider)
      .forEach((node) => {
        this.prefSliders.push(new PrefSlider({ app: this, node }));
      });

    this.selects = [];
    this.store.config.selectTypes.forEach((select) => {
      this.selects.push(
        new Select({
          app: this,
          node: document.querySelector(
            this.store.config.selector[`${select}Select`]
          ),
          type: select,
        })
      );
    });

    this.submitBtns = [];
    document
      .querySelectorAll(this.store.config.selector.submitBtn)
      .forEach((node) => {
        this.submitBtns.push(
          new SubmitBtn({
            app: this,
            node,
          })
        );
      });

    // Node of Assist UI
    //

    this.loader = new Loader({
      app: this,
      node: document.querySelector(this.store.config.selector.loader),
    });

    // Node of Result UI
    //
    this.reSearchBtn = new ReSearchBtn({
      app: this,
      node: document.querySelector(this.store.config.selector.reSearchBtn),
    });

    this.spotItems = new SpotItems({
      app: this,
      node: document.querySelector(this.store.config.selector.spotItems),
    });

    this.resultMsg = new ResultMsg({
      app: this,
      node: document.querySelector(this.store.config.selector.resultMsg),
    });

    this.resultNoItemMsg = new ResultNoItemMsg({
      app: this,
      node: document.querySelector(this.store.config.selector.resultNoItemMsg),
    });

    this.courseCopyBtn = new CourseCopyBtn({
      app: this,
      node: document.querySelector(this.store.config.selector.courseCopyBtn),
    });

    // Initial State & Render View
    //
    // - 現在undefinedとなっているstateの初回割り当てを行う
    // - これにより各stateに関係したデザインコンポーネントがrenderメソッドにより見た目を更新する

    // A. アプリ実行者側の指定で初期値が決まるstateの初期化
    this.setState('activePrefBundlerBtnId', activePrefBundlerBtnId);
    this.setState('activeTasteBundlerBtnId', activeTasteBundlerBtnId);

    const activeTasteBundlerBtn = this.tasteBundlerBtns.find(
      (btn) => btn.id === this.getState('activeTasteBundlerBtnId')
    );
    this.setState('taste', {
      ...activeTasteBundlerBtn?.params,
      ...this.tasteSlider?.params,
    });

    // ★ ここを追加：taste4 が未定義なら 2 を入れる
    const currentTaste = this.getState('taste') || {};
    if (currentTaste.taste4 == null) {
      this.setState('taste', {
        ...currentTaste,
        taste4: 2,
      });
    }

    // A. アプリ実行者側… のあと
    const activePrefBundlerBtn = this.prefBundlerBtns.find((btn) => {
      return btn.id === this.getState('activePrefBundlerBtnId');
    });
    this.setState('pref', activePrefBundlerBtn.params);

    console.log(
      '[Aic] selects:',
      this.selects.map((s) => ({
        type: s.type,
        nodeExists: !!s.node,
        value: s.node && s.node.value,
      }))
    );

    //  ここから追加（元々あったやつを復活）
    // B. 初期 html のセレクト状態から state を初期化
    this.selects.forEach((select) => {
      if (!select.node) return;

      const value = select.node.value;

      // ここで「実質的に未選択」の値を弾く
      if (
        value != null &&
        value !== '' &&
        value !== 'undefined' &&
        value !== 'null'
      ) {
        this.setState(select.type, value);
      }
    });
    console.log(
      '[debug] selects:',
      this.selects.map((s) => ({
        type: s.type,
        nodeExists: !!s.node,
      }))
    );
  }

  I18n(word) {
    const targetWord =
      this.store.config.translation[this.store.config.locale][word];
    const defaultWord =
      this.store.config.translation[this.store.config.defaultLocale][word];
    const dispWord = targetWord ? targetWord : defaultWord;

    return dispWord;
  }

  getState(targetState) {
    return this.store.state[`_${targetState}`];
  }

  setState(targetState, v) {
    this.store.state[`_${targetState}`] = v;

    switch (targetState) {
      case 'activeTasteBundlerBtnId':
        this.tasteBundlerBtns.forEach((btn) => btn.render());
        break;

      case 'activePrefBundlerBtnId':
        this.prefBundlerBtns.forEach((btn) => btn.render());
        break;

      case 'taste':
        if (this.tasteSlider && this.tasteSlider.render) {
          this.tasteSlider.render();
        }
        break;

      case 'pref':
        this.prefSliders.forEach((slider) => slider.render());
        break;

      // API 取得系：揃ったら mixInfo を更新
      case 'aicAPIInfo':
      case 'wpAPIInfo':
        // aic / wp が両方揃っていれば mixInfo を更新
        this.updateMixInfo();
        break;

      // 結果表示系：これらが変わった時だけ Result UI を描画
      case 'mixInfo':
      case 'hasValidSpotData':
      case 'isFetching':
        this.loader.render();
        this.spotItems.render();
        this.courseCopyBtn.render();
        this.resultMsg.render();
        this.resultNoItemMsg.render();
        break;

      case 'isShownForm':
        this.reSearchBtn.render();
        this.form.render();
        break;

      default:
        // 他の state は UI 連動なし
        break;
    }

    // Debug & HTML に state を保存
    this.form.node.dataset.state = JSON.stringify(this.store.state);
    console.log(`[debug] ${targetState}情報が更新されました`, this.store.state);
  }

  getQueries() {
    const taste = this.getState('taste') || {};
    const pref = this.getState('pref') || {};
    const btnName = this.getState('activePrefBundlerBtnId');
    const btnId = btnName.replace(/[^0-9]/g, '');
    let setStartTime;
    if (btnId === '6') {
      setStartTime = 6;
    } else {
      setStartTime = this.getState('startTime');
    }

    let params = '';

    params += `&apikey=${this.store.config.apiKey}`;
    params += `&place=${this.store.config.place}`;

    const startSpot = this.getState('startSpot');
    if (startSpot != null && startSpot !== '') {
      params += `&start_spot_id=${startSpot}`;
    }

    const duration = this.getState('duration');
    if (duration != null && duration !== '') {
      params += `&duration=${duration}`;
    }

    if (setStartTime != null && setStartTime !== '') {
      params += `&start_time=${setStartTime}`;
    }

    const days = this.getState('days');
    if (days != null && days !== '') {
      params += `&days=${days}`;
    }

    const transportation = this.getState('transportation');
    if (transportation != null && transportation !== '') {
      params += `&transportation=${transportation}`;
    }

    params += `&taste=${taste['taste1']},${taste['taste2']},${taste['taste3']},${taste['taste4']}`;
    params += `&pref=${pref['pref1']},${pref['pref2']},${pref['pref3']},${pref['pref4']},${pref['pref5']}`;

    const special = pref['special'];
    if (special != null && special !== '') {
      params += `&special=${special}`;
    }

    return params;
  }

  updateMixInfo() {
    console.groupCollapsed('[updateMixInfo] start');

    const aic = this.getState('aicAPIInfo'); // = aicResponse
    const wp = this.getState('wpAPIInfo');

    console.log('[updateMixInfo] aicAPIInfo =', aic);
    console.log('[updateMixInfo] wpAPIInfo  =', wp);

    // AIC / WP のどちらかがない場合はまだマージしない
    if (!aic || !wp) {
      console.warn(
        '[updateMixInfo] aicAPIInfo または wpAPIInfo が未取得のためスキップ'
      );
      console.groupEnd();
      return;
    }

    const currentLocale = this.store.config.locale; // 例: 'en'
    const defaultLocale = this.store.config.defaultLocale; // 例: 'ja'

    const rtnInfos = { ...aic };

    rtnInfos.plan_infos = (rtnInfos.plan_infos || []).map((info) => {
      // ★ 同じ external_id (= jcid) を持つ WP 記事をすべて取得
      const matchedPosts = wp.filter(
        (wpInfo) => info.spot_id === wpInfo.external_id
      );

      if (!matchedPosts.length) {
        console.warn('[updateMixInfo] no WP match for spot_id:', info.spot_id);
        return info;
      }

      console.log(
        '[updateMixInfo] matchedPosts for spot_id',
        info.spot_id,
        matchedPosts.map((p) => `${p.locale}:${p.title}`)
      );

      // ★ locale の優先順位
      const selected =
        matchedPosts.find((p) => p.locale === currentLocale) ||
        matchedPosts.find((p) => p.locale === defaultLocale) ||
        matchedPosts[0];

      info.title = selected.title;
      info.description = selected.description;
      info.pic_path = selected.pic_path;
      info.permalink = selected.permalink;

      // デバッグ・将来用に全言語も保持
      info.localizedPosts = matchedPosts;

      return info;
    });

    if (rtnInfos.plan_infos.length) {
      this.setState('hasValidSpotData', true);
      this.setState('mixInfo', rtnInfos);
    } else {
      this.setState('hasValidSpotData', false);
    }

    console.groupEnd();
  }

  // [todo] ハードコードです。
  scrollAppTopLoc() {
    const rect = document
      .querySelector('#aic-result-head')
      .getBoundingClientRect();
    document.documentElement.scrollTop = rect.top + window.pageYOffset;
  }
}
